import Master from "./Master";

const UserType = (props) => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const submitUrl = apiEndPoint + "/UserType/";
  const parentSource = apiEndPoint + "/UserTypeForSelect/";
  const getAllUrl = apiEndPoint + "/UserTypeAll/";
  const deleteUrl = apiEndPoint + "/UserType/";
  const masterProps = {
    masterlabel: "User Types",
    id: "ut-master",
    variant: "primary",
    submitUrl: submitUrl,
    getAllUrl: getAllUrl,
    deleteUrl: deleteUrl,
    primaryKey: "user_type_id",
    newEntryForm: props?.newEntryForm === undefined ? true : props.newEntryForm,
    fields: [
      {
        label: "Name",
        props: { required: true },
        ref: "user_type_name",
      },
      {
        label: "Parent",
        controlType: "select",
        props: { required: true },
        defaultLabel: "Select Parent User Type",
        options: [
          {
            label: "Root",
            value: 0,
          },
        ],
        dataUrl: parentSource,
        ref: "parent_user_type_id",
        tableValue: "parent_user_type_name",
      },
    ],
  };
  return <Master {...masterProps} />;
};
export default UserType;
